module.exports = __webpack_public_path__ + "img/games-svg-icon.f64101a1.svg";